<template>
<navBack></navBack>
  <div class="page">
    <div v-if="couponList.length === 0 && isOver">
      <div class="imgBox">
        <image src="https://img01.yzcdn.cn/vant/empty-image-search.png"></image>
      </div>
      <div class="emptyInfo">暂无礼券</div>
    </div>

    <div class="mainBox">
      <coupon-bar v-for="(item, index) in couponList" :key="index" :coupon="item" :data-index="index">
        <t-button size="extra-small" :data-index="index" style="color:black;font-weight: normal;"
          @click="sendThisCoupon(index)" :loading="isSending&&index===chosedCouponIndex">
          发送
        </t-button>
      </coupon-bar>
    </div>
  </div>

  <t-dialog v-model:visible="confirmDialogVisible" close-on-overlay-click title="确认发送此礼券?" cancel-btn="取消"
    :confirm-btn="{ content: '确定', variant: 'base', theme: 'light' }" @confirm="onSendConfirm" @cancel="onSendCancel">
  </t-dialog>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue'
import { Toast } from 'tdesign-mobile-vue'
import couponBar from '@/components/coupon-bar.vue'
import { stateShop, stateCustomer,stateReloadCustomer } from '@/store'
import navBack  from '@/components/nav-back.vue'
const { proxy } = getCurrentInstance()
const app = proxy.$cloudbase


// 响应式数据
const isOver = ref(false)
const pageIndex = ref(1)
const couponList = ref([])
const chosedCouponIndex = ref(0)
const confirmDialogVisible = ref(false) // 添加缺失的响应式变量

const isSending = ref(false);
// 发送礼券方法
const sendThisCoupon = (index) => {
  confirmDialogVisible.value = true
  chosedCouponIndex.value = index
}

// 取消发送
const onSendCancel = () => {
  confirmDialogVisible.value = false
}

// 确认发送礼券
const onSendConfirm = async () => {
  try {

isSending.value = true;
    const coupon = couponList.value[chosedCouponIndex.value]

    const { result } = await app.callFunction({
      name: 'my_openapi',
      data: {
        op: 'send_coupon_to_some_user',
        shopId: stateShop._id,
        couponId: coupon._id,
        customerList: [stateCustomer],
        note: '管理员赠送'
      }
    })



    if (result == 'ok')
      Toast('发送成功')
    else
      Toast('发送失败')
  
      stateReloadCustomer.value=true;
  } catch (error) {

    console.error('发送礼券失败:', error)
    Toast('发送失败')
  } finally {
    confirmDialogVisible.value = false;
    isSending.value = false;
  }
}

// 加载礼券列表
const loadCouponList = async () => {
  if (isOver.value) {
    Toast('没有更多')
    return // 修复拼写错误: retur -> return
  }

  try {
    const db = app.database()
    const _ = db.command

    const queryData = {
      'status': _.gt(0),
      shopId: stateShop._id
    }

    const _pageSize = 20
    const _skipNum = (pageIndex.value - 1) * _pageSize

    const res = await db.collection("my_coupon")
      .where(queryData)
      .orderBy('createAt.timeStamp', 'desc')
      .skip(_skipNum)
      .limit(_pageSize)
      .get()

    console.log(res.data, 'res.data')

    if (res.data.length < _pageSize) {
      isOver.value = true
    }

    pageIndex.value++
    couponList.value = [...couponList.value, ...res.data]
  } catch (error) {
    console.error('加载礼券失败:', error) // 修改错误信息更准确
    Toast('加载失败')
  }
}

// 生命周期
onMounted(() => {
  console.log('礼券列表加载')
  loadCouponList() // 修复方法名拼写: loadcouponList -> loadCouponList
})
</script>

<style scoped>
.page {
  padding-top: 10vw;
  background-color: #f6f6f6;
 
  padding-bottom: 2vw;

}

.imgBox image {
  width: 40vw;
  height: 40vw;
}

.mainBox {
  overflow-y: auto;
  height: calc(90vh - 3vw);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.imgBox {
  margin-top: 15vw;
  padding: 12vw;
  display: flex;
  width:100%;
  box-sizing: border-box;
  justify-content: center;
}

.emptyInfo {
  color: gray;
  text-align: center;
}
</style>